<script lang="ts">
  import { sortedDistributors } from "@retailer/services/distributor_service";
  import ObjectPickerCard from "@shared/svelte/Components/ObjectPickerCard.svelte";
  import LastOrdered from "@retailer/svelte/ProductDetails/Components/LastOrdered.svelte";
  import ProductLineLastOrderedStore from "@retailer/svelte/stores/ProductLineLastOrderedStore";
  import { DistributorEntity, ProductLineEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";

  import type { ProductLine } from "@shared/types/ProductLine";
  import type { Distributor } from "@shared/types/Distributor";

  const { trackClick } = EventTracking;
  export let selectedDistributor: Distributor;
  export let distributors: Distributor[] = [];
  export let productLine: ProductLine;
  export let selectDistributor: (distributor: Distributor) => void;

  // The prop changing will reset this value, but we set it in state immediately before firing api calls
  let selected: Distributor = selectedDistributor;

  const distributorSelection = sortedDistributors(distributors);

  const onSelect = (distributor: Distributor) => {
    selected = distributor;
    selectDistributor(distributor);

    trackClick("pdp_dual_product_select_distributor", [
      new DistributorEntity({ id: distributor.id }),
      new ProductLineEntity({ productLineId: productLine.id }),
    ]);
  };

  let previousOrder;
  $: {
    previousOrder = $ProductLineLastOrderedStore.getLastOrderedForProductLine(productLine.id);
  }

</script>

<div data-testid="distributor-choice" class="fizz-stack-12">
  <ObjectPickerCard
    header="Select a distributor"
    values={distributorSelection}
    selectValue={onSelect}
    selectedValue={selected}
    key="name"
    showSlot={!!previousOrder}
  >
    <LastOrdered {previousOrder} />
  </ObjectPickerCard>
</div>
